import { ModelBase } from '../../core/model/model-base';

export class Attachment extends ModelBase {
  caption: string;
  size: number;
  extension: string;
  data: any;
  mimeType: string;
  title: string;
  src: string;
  originalName: string;
}
